import React from "react";
import MultiTabPerfil from "../MultiTabPerfil/MultiTabPerfil";
import { TabsData } from "./TabsData";
import "./PerfilDatosPersonalesStyle.css";
import { TabsEstilo } from "./TabsEstilo";


const ProfileColumn1 = () => {
  return (
    <React.Fragment>
        <MultiTabPerfil tabs={TabsData} estilos={TabsEstilo}/>
    </React.Fragment>
  );
};

export default ProfileColumn1;
